export default {
    variants: {
        accountLink: {
            fontSize: 'md',
            fontWeight: 'normal'
        },
        accountInfo: {
            fontSize: 'sm',
            fontWeight: 'medium'
        },
        accountInfoSmall: {
            fontSize: 'xs'
        },
        accountStatus: {
            fontSize: 'md',
            fontWeight: 'bold'
        },
        barcodeText: {
            textStyle: 'bodySmRegular'
        },
        textWithSymbol: {
            fontSize: {base: 'xs', lg: 'sm'},
            fontWeight: 'medium',
            _after: {
                color: 'progressPink.500',
                fontSize: '17px'
            }
        },
        promoBarText: {
            fontSize: 'xs',
            fontWeight: 'bold'
        },
        gcInfo: {
            fontSize: 'sm',
            fontWeight: 'semibold'
        },
        gcTitle: {
            fontSize: 'sm',
            fontWeight: 'bold'
        },
        leaveModalText: {
            fontSize: 'sm',
            fontWeight: 'normal'
        },
        drawerTitle: {
            textStyle: 'webH2'
        },
        infoCardText: {
            fontSize: {base: 'xs', lg: 'sm'},
            fontWeight: 'normal',
            color: 'webTypo.textSecondary'
        },
        infoCardTitle: {
            fontSize: {base: 'xs', lg: 'sm'},
            fontWeight: 'bold',
            textTransform: 'uppercase',
            color: 'webTypo.textPrimary'
        },
        infoCardBadge: {
            fontSize: 'xs',
            fontWeight: 'normal',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'black',
            px: '4px',
            py: '2px',
            lineHeight: '1'
        },
        smartSearchHeading: {
            textStyle: 'webH3',
            mb: 2
        },
        smartSearchSubtitle: {
            fontSize: 'sm',
            fontWeight: 'normal',
            mb: 6
        },
        smartSearchTry: {
            fontSize: 'xs',
            fontWeight: 'normal',
            color: 'gray.700',
            mb: 3
        }
    }
}
